<template>
    <v-container fluid fill-height>
        <v-layout style="display: block;">
            <quiz-by-kti-index/>
        </v-layout>
    </v-container>
</template>
<script>
    import QuizByKtiIndex from "../../components/student/QuizByKti/QuizByKtiIndex";
    export default  {
        components: {
            QuizByKtiIndex,
        }
    }
</script>